export const MONTHS_IT = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export const WEEKDAYS_IT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

// YYYY-MM-DD -> gg/mm/aaaa
export function formatDateIT(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function monthKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}

export function monthLabel(date) {
  return `${MONTHS_IT[date.getMonth()]} ${date.getFullYear()}`;
}

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function fmtHours(h) {
  const n = Number(h) || 0;
  return n % 1 === 0 ? `${n}` : n.toFixed(2).replace(".", ",");
}

export function fmtEuro(n) {
  const v = Number(n) || 0;
  return v.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}

export function fmtPct(n) {
  if (n === null || n === undefined) return "—";
  return `${Number(n).toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`;
}

// Parse a user-typed number allowing Italian comma decimals ("12,50" -> 12.5).
export function parseNum(v) {
  if (v === "" || v === null || v === undefined) return 0;
  const n = parseFloat(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}
